function getScrollableAncestors(node) {
  const ancestors = [];
  let parent = node?.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const overflowY = style.overflowY;
    if (
      (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") &&
      parent.scrollHeight > parent.clientHeight + 1
    ) {
      ancestors.push(parent);
    }
    parent = parent.parentElement;
  }

  return ancestors;
}

export function scrollElementIntoView(node, { offset = 72, behavior = "smooth", block = "start" } = {}) {
  if (!node?.getBoundingClientRect) return;

  if (block === "center") {
    scrollElementIntoViewCenter(node, { behavior });
    return;
  }

  node.scrollIntoView({ behavior, block: "start", inline: "nearest" });

  const scrollRoots = [
    document.scrollingElement,
    document.documentElement,
    document.body,
    document.querySelector(".v-application__wrap"),
    ...getScrollableAncestors(node),
  ].filter(Boolean);

  const uniqueRoots = [...new Set(scrollRoots)];

  requestAnimationFrame(() => {
    const rect = node.getBoundingClientRect();

    for (const root of uniqueRoots) {
      if (root === document.body || root === document.documentElement) {
        const top =
          (window.scrollY || root.scrollTop || 0) + rect.top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior });
        continue;
      }

      const rootRect = root.getBoundingClientRect();
      const top = root.scrollTop + rect.top - rootRect.top - offset;
      root.scrollTo({ top: Math.max(0, top), behavior });
    }
  });
}

export function scrollElementIntoViewCenter(node, { behavior = "smooth" } = {}) {
  if (!node?.getBoundingClientRect) return;

  const scrollRoots = [
    document.scrollingElement,
    document.documentElement,
    document.body,
    document.querySelector(".v-application__wrap"),
    ...getScrollableAncestors(node),
  ].filter(Boolean);

  const uniqueRoots = [...new Set(scrollRoots)];

  requestAnimationFrame(() => {
    const rect = node.getBoundingClientRect();

    for (const root of uniqueRoots) {
      if (
        root === document.body ||
        root === document.documentElement ||
        root === document.scrollingElement
      ) {
        const top =
          window.scrollY + rect.top - (window.innerHeight - rect.height) / 2;
        window.scrollTo({ top: Math.max(0, top), behavior });
        continue;
      }

      const rootRect = root.getBoundingClientRect();
      const top =
        root.scrollTop +
        rect.top -
        rootRect.top -
        (root.clientHeight - rect.height) / 2;
      root.scrollTo({ top: Math.max(0, top), behavior });
    }
  });
}
